import styled from "styled-components";

export const LogoBGStyled = styled.div`
  position: fixed;
  opacity: ${(props) => (props.darkmode ? `4%` : "10%")};
  left: 0%;
  top: 0;
  display: flex;
  align-items: center;
  height: 100%;
  z-index: 0;
  img {
    height: 100%;
  }
`;
